import { Container } from '@vnetwork/ui/layout';
import { Alert } from '@vnetwork/ui/feedback';
import { Button } from '@vnetwork/ui/primitives';
import { useOpsDashboard } from '@/api/operations-org-hooks';
import { OpsDashboardStatBand } from './dashboard/ops-dashboard-stat-band';
import { OpsActivationTrendWidget } from './dashboard/ops-activation-trend-widget';
import { OpsCategoryBreakdownWidget } from './dashboard/ops-category-breakdown-widget';
import { OpsTopOrgsWidget } from './dashboard/ops-top-orgs-widget';

/**
 * Operations landing page — platform-wide dashboard for internal ops staff.
 * No PageHeader (per ui-conventions: dashboard starts straight at content).
 * Grid layout: stat band (6 cols) → trend (2/3) + breakdown (1/3) → top orgs (full).
 */
export default function OperationsDashboardPage() {
  const { data, isLoading, isError, refetch } = useOpsDashboard();

  if (isError) {
    return (
      <Container size="full">
        <Alert
          tone="danger"
          title="Failed to load dashboard"
          actions={
            <Button size="sm" variant="ghost" onClick={() => refetch()}>
              Retry
            </Button>
          }
        />
      </Container>
    );
  }

  return (
    <Container size="full">
      <div
        style={{
          display: 'grid',
          gap: 'var(--vn-space-4)',
        }}
      >
        {/* Stat band — 6 KPI cards */}
        <OpsDashboardStatBand />

        {/* Row: activation trend (wider) + category breakdown */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr',
            gap: 'var(--vn-space-4)',
          }}
        >
          <OpsActivationTrendWidget
            trend={data?.activation_trend}
            isLoading={isLoading}
          />
          <OpsCategoryBreakdownWidget
            byCategory={data?.by_category}
            isLoading={isLoading}
          />
        </div>

        {/* Row: top orgs — full width */}
        <OpsTopOrgsWidget topOrgs={data?.top_orgs} isLoading={isLoading} />
      </div>
    </Container>
  );
}
